import React from "react";

import { useState , useId} from "react";


const options = [
            {
                id : 'all',
                label: 'All'
            },
            {
                id : '1Y',
                label: '1Y'
            },
            {
                id : 'YtD',
                label: 'YtD'
            },
            {   
                id : '6m',
                label: '6m'
            },
            {
                id : '3m', 
                label: '3m'           
            },
            {
                id : '30d',
                label: '30d'            
            },
            {
                id : 'tm',
                label: 'this month'            
            }
            
        ];

        

let labelClassName = ` 
              text-[9px] font-light
              cursor-pointer p-1 rounded-full border border-zinc-600 transition-colors
              bg-gradient-to-b from-neutral-50 to-zinc-300
              
              has-[:checked]:bg-gradient-to-b 
              has-[:checked]:from-zinc-300 
              has-[:checked]:to-neutral-50
              has-[:checked]:text-green-500 
              has-[:checked]:font-semibold
              

              hover:bg-gray-50
          `;

let inputClassName = ' sr-only';

export default function VisualFilterButtons ({visualState, setVisualState}){

    //const [isChecked, setIsChecked] = useState(visualState);

    // Genera un ID base único para esta instancia del componente
    const baseId = useId();
    
    function handleChange(event){
    
              console.log('visual filter applied: ',event.target.value)
    
              setVisualState(event.target.value);
              //setIsChecked(event.target.value);
    
    }
    
    return (
              <div className="flex flex-row justify-evenly">
    
                  {
                    options.map((option,index)=>{ 
                        
                        const uniqueId = `${baseId}-${option.id}`; 
                        
                        
                        return (
                    
                        
                      <label key={`visual-filter-butt-${uniqueId}`} htmlFor={`visual-filter-butt-${uniqueId}`} className={`` + labelClassName}>    
                                  <input type="radio"
                                        id={`visual-filter-butt-${uniqueId}`}
                                        name={`visualState`}
                                        value={option.id}
                                        
                                        className={
                                                            
                                          inputClassName + `  `
                      
                                        } 
                                        
                                        onChange={handleChange}
                                        checked={visualState === option.id}                                   
                                  />{option.label}
                      </label>
    
                    )
                    
                    
                    } 
                    )
                  }         
                            
              </div>
    );

}